var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "tc-table-status" },
    [
      _vm.pagination.total_object_count > 0
        ? [_vm._v("\n        " + _vm._s(_vm.statusText) + "\n    ")]
        : [
            _c("div", { staticClass: "message is-info status-message" }, [
              _c("div", { staticClass: "message-body is-size-7" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$gettext("No results.")) +
                    "\n            "
                ),
              ]),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }